import {createApp} from 'vue'
import FrivilligeCheckoutStepTwo from './FrivilligeCheckoutStepTwo'

const el = '.kb-component--frivillige-checkout-step-two'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FrivilligeCheckoutStepTwoDOM)=>{
            const component = createApp(FrivilligeCheckoutStepTwo).use(Store)
            component.mount(FrivilligeCheckoutStepTwoDOM)
        })
    }
}